export default __webpack_public_path__ + "static/media/gallery-wip-3d-print_02.5a714fb2.jpg";